import { useState } from 'react';
import { StoryFramesModel } from 'interface/models';
import { StoryFrame } from '../StoryBoard/StoryFrame';
import { Drawer, Button, Tag } from 'antd';
import { EditOutlined } from '@ant-design/icons';

export const TimelinePlan_EditFrame = (props: { onReload: any; storyId: number; frame: StoryFramesModel; displayType: string }) => {
  const [isDrawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => setDrawerVisible(true);
  const closeDrawer = () => setDrawerVisible(false);

  return (
    <>
      <Tag onClick={showDrawer} icon={<EditOutlined />} />
      <Drawer title="Edit frame" placement="right" onClose={closeDrawer} visible={isDrawerVisible} width={'50%'}>
        <StoryFrame
          key={props.frame.id + `StoryFrame`}
          frame={props.frame}
          displayType={`text-drawer`}
          storyId={props.storyId}
          onChange={props.onReload}
          onReload={props.onReload}
        />
      </Drawer>
    </>
  );
};
